import {Component, Input, Output, EventEmitter, ViewChild, OnChanges, SimpleChanges, OnInit} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../services/auth.service";
import {Observable} from "rxjs";
import {MicroSelectComponent} from "../shared/select/micro-select.component";

@Component({
  selector: 'micro-taskSprint-select',
  templateUrl: './taskSprint-select.component.html'
})
export class TaskSprintSelectComponent implements OnInit, OnChanges {

  @ViewChild("sel", {static: true}) sel:MicroSelectComponent;

  @Input()
  mode:string = 'simple';

  @Input()
  taskCarrierId:any;

  @Input()
  taskResourceId:any;

  @Output()
  taskSprintIdChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  taskSprintId:any;

  @Output()
  valueChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  value:any = '';

  @Input()
  required:boolean = false;

  initialized:boolean = false;

  options:any[];

  @Input()
  disabled:boolean = false;

  isDisabled() {
    return this.disabled || !this.taskCarrierId || !this.taskResourceId;
  }

  requires() {
    if (!this.taskCarrierId || this.taskCarrierId === '') {
      return "--TASK CARRIER--";
    }

    if (!this.taskResourceId || this.taskResourceId === '') {
      return "--TASK RESOURCE --";
    }

    return null;
  }

  change(e) {

    this.taskSprintIdChange.emit(this.taskSprintId);
    this.valueChange.emit(this.sel.getSelectedValue());
  }

  constructor(private auth:AuthService, private env:EnvService, private http:HttpClient) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (let prop in changes) {
      if (prop === 'taskCarrierId' || prop === 'taskResourceId') {
        this.reload();
      }
    }
  }

  valueCallback(option) {
    return `#${option.id} - ${option.typeName}`;
  }

  reload() {
    if (!this.taskCarrierId || this.taskCarrierId === '' || !this.taskResourceId || this.taskResourceId === '' || !this.initialized) {
      return;
    }

    let params:HttpParams = new HttpParams()
      .set("taskCarrierId", this.taskCarrierId)
      .set("taskResourceId", this.taskResourceId)
      ;

    this.sel.loading = true;
    return this.http.get(`${this.env.e.url}/task/omni/sprints`, {params:params})
      .subscribe(data => {
        this.options = data as any[];
        this.sel.loading = false;
      });
  }

  ngOnInit(): void {
    this.initialized = true;
    this.reload();
  }
}
